(() => {
  const instances = new WeakMap();
  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

  function initTimeline(section) {
    if (instances.has(section) || section.dataset.animated !== "true" || reducedMotion.matches) return;

    const wrapper = section.querySelector("[data-timeline-wrapper]");
    const progress = section.querySelector("[data-timeline-progress]");
    const cards = [...section.querySelectorAll("[data-timeline-card]")];
    const reveals = [...section.querySelectorAll("[data-timeline-reveal]")];
    if (!wrapper || !progress || !cards.length) return;
    section.classList.add("eusari-subscription-timeline--enhanced");

    const fadeObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-visible");
        fadeObserver.unobserve(entry.target);
      });
    }, { rootMargin: "0px 0px -15% 0px", threshold: 0.1 });

    reveals.forEach((element) => fadeObserver.observe(element));

    let frame;
    let listening = false;
    const update = () => {
      frame = undefined;
      const rect = wrapper.getBoundingClientRect();
      const activationLine = window.innerHeight * 0.6;
      const value = Math.max(0, Math.min(1, (activationLine - rect.top) / rect.height));
      progress.style.setProperty("--timeline-progress", value);
      cards.forEach((card) => card.classList.toggle("is-active", card.getBoundingClientRect().top < activationLine));
    };

    const requestUpdate = () => {
      if (!frame) frame = window.requestAnimationFrame(update);
    };

    const setListening = (enabled) => {
      if (enabled === listening) return;
      listening = enabled;
      if (enabled) {
        window.addEventListener("scroll", requestUpdate, { passive: true });
        window.addEventListener("resize", requestUpdate, { passive: true });
        requestUpdate();
      } else {
        window.removeEventListener("scroll", requestUpdate);
        window.removeEventListener("resize", requestUpdate);
      }
    };

    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => setListening(entry.isIntersecting));
    }, { rootMargin: "100% 0px 100% 0px" });
    sectionObserver.observe(section);

    instances.set(section, () => {
      setListening(false);
      fadeObserver.disconnect();
      sectionObserver.disconnect();
      if (frame) window.cancelAnimationFrame(frame);
      section.classList.remove("eusari-subscription-timeline--enhanced");
      instances.delete(section);
    });
  }

  function destroyTimeline(section) {
    instances.get(section)?.();
  }

  function initAll(root = document) {
    if (root.matches?.('.eusari-subscription-timeline[data-animated="true"]')) initTimeline(root);
    root.querySelectorAll?.('.eusari-subscription-timeline[data-animated="true"]').forEach(initTimeline);
  }

  document.addEventListener("DOMContentLoaded", () => initAll());
  document.addEventListener("shopify:section:load", (event) => initAll(event.target));
  document.addEventListener("shopify:section:unload", (event) => {
    if (event.target.matches?.(".eusari-subscription-timeline")) destroyTimeline(event.target);
    event.target.querySelectorAll?.(".eusari-subscription-timeline").forEach(destroyTimeline);
  });
})();
